import MaxImage from '../Media/maxli.webp'
import ArthurImage from '../Media/art.webp'

import Rob from '../Media/rob.webp'
import Vitaly from '../Media/Vitaly.webp'

import Arthur from '../Media/ar.webp'

import Joe from "../Media/1000008288.webp"
import Matt from "../Media/1000008223.webp"
import Goran from "../Media/Goran.webp"
import Thusean from "../Media/Thusean.webp"
import Isaiah from "../Media/Isaiah.webp"
import Ivan from "../Media/Ivan.webp"
const CoachesList = 
[

{
    name: "Мах",
 
    headInstructor: true,
    description: "A black belt under Jorge Britto, Мах brings nearly 15 years of BJJ experience. A multiple-time IBJJF Open Champion, Canadian National Champion, ADCC Toronto Open Champion, and Ontario Open Gold Medalist. He also has 10 amateur Muay Thai fights, 5 amateur MMA fights, an amateur MMA Championship, and a 1-0 professional MMA record.",
    accomplishments:["Canadian National Champion", "Multiple Time IBJJF Open Champion", "IBJJF American Nationals Bronze Medalist", "Ontario Open Gold Medalist", "Amateur MMA Champion", "1-0 Pro MMA Record"],
    image: MaxImage,
    link: 'https://www.instagram.com/maxli5000'
},
 
{
  name: "Artur",

  description: "With over 30 years of wrestling experience, Artur is a decorated competitor from Dagestan — a former regional champion and champion of Southern Russia, holding the prestigious title of Master of Sport in Freestyle Wrestling. He also has an extensive Muay Thai & MMA background and has trained alongside elite fighters including Alexander Volkov and Zabit Magomedsharipov.",
 
  accomplishments:["30+ Years of Wrestling", "Dagestan Regional Wrestling Champion", "Freestyle Wrestling Champion of Southern Russia", "Freestyle Wrestling Master of Sport (Russia)", "Trained with the likes of Alexander Volkov and Zabit Magomedsharipov" , "Winner of the Ivan Yarygin Wrestling Tournament" ],
  image:Arthur,
  link: 'https://www.instagram.com/ar_knv/',
    setmoreLink: 'https://maplejiujitsu.setmore.com/artur-k'
},

{
  name: "Ivan",

  description: "Ivan Primorac brings over 20 years of Muay Thai experience and a deep background in international competition. His coaching blends authentic technique, traditional fundamentals, and modern fight strategy into every session. Ivan emphasizes technical precision, conditioning, and fight IQ — developing confident, well-rounded strikers from the ground up.",
 
  accomplishments:["30+ Years of Wrestling", "Dagestan Regional Wrestling Champion", "Freestyle Wrestling Champion of Southern Russia", "Freestyle Wrestling Master of Sport (Russia)", "Trained with the likes of Alexander Volkov and Zabit Magomedsharipov" , "Winner of the Ivan Yarygin Wrestling Tournament" ],
  image:Ivan,
 
    setmoreLink: 'https://maplejiujitsu.setmore.com/artur-k'
},

  {name: "Arturion",
    belt:"Purple Belt",
    accomplishments:[, "AJP Gold Medalist", "Next-Gen Gold Medalist", "Ontario Open Silver Medalist", "IBJJF London Open Bronze Medalist", "ADCC Canada 4th place", "Godai Open Bronze Medallist"],
    description: "A purple belt in Brazilian Jiu-Jitsu, Arturion has been training for 5 years and has already made a name for himself in competition. He has won gold at the AJP and Next-Gen tournaments, secured a silver medal at the Ontario Open, and earned a bronze at the IBJJF London Open. Additionally, he placed fourth at ADCC Canada and took Gold at the Godai Open.",
    image:ArthurImage,
    link: 'https://www.instagram.com/cucarachinho',
    setmoreLink: 'https://maplejiujitsu.setmore.com/arthur-li'
  },
]

const Backup = [
  
{
  name: "Vitaly",
  belt:"Black Belt",
 
  description: "Black belt with over 10 years of experience",
  accomplishments:["Grappling Industries Gold Medalist", "ADCC Canada Silver Medalist", "Ontario Open Silver Medalist"],
  image:Vitaly
},

  {
    name: "Rob",
    belt:"Black Belt",
   
    description: "Black belt with nearly 20 years of experience.",
    accomplishments:["Oshawa Open Gold Medalist", "Professional MMA Experience"],
    image:Rob
  },


  {
  name: "Goran",

  description: "A brown belt with 8 years of dedicated Brazilian Jiu-Jitsu training, Goran has developed a reputation for his relentless pace and sharp technical game. In 2023, he captured gold at Grappling Industries as a purple belt, showcasing his ability to dominate in high-level competition. Known among his teammates for his strategic mindset and pressure-heavy style, Goran continues to refine his craft and push the boundaries of his performance on the mats.",
 
 
   image:Goran
 
 
},



  {name: "Thusean",
  belt:"Blue Belt",
  accomplishments:[],
  description: "With about 5 years of dedicated training in Brazilian Jiu-Jitsu & MMA, Thusean has already made a strong impact on the competition scene, secureing a gold at the 905 Championship, and added a bronze medal from the GTA Classic. His steady progress and competitive spirit continue to push him forward in the sport.",
  image:Thusean,
  link: 'https://www.instagram.com/thenightmare155',
 
},


 

{name: "Matt",
  belt:"Brown Belt",
  accomplishments:[],
  description: "Matt is a brown belt with over 12 years of experience in Brazilian Jiu-Jitsu. Known for his technical approach and dedication to the art, he has spent years refining his skills on the mats. His commitment to continuous improvement and deep understanding of the sport make him a respected member of the BJJ community.",
  image:Matt, 
},

{name: "Joe",
  belt:"Purple Belt",
  accomplishments:["Ontario Open Silver Medalist", "Provincial Champion"],
  description: "With over 10 years of experience in Brazilian Jiu-Jitsu, Joe has built a solid foundation in the sport. Throughout his time on the mats, he has achieved notable accomplishments, including a silver medal at the Ontario Open and a Provincial Championship title. His consistent training and commitment to learning continue to shape his journey in BJJ.",
  image:Joe,
  link: 'https://www.instagram.com/bullbulan',
 
},

{
  name: "Isaiah",
  belt: "Blue Belt",
  accomplishments: [
    "Submission Arts United Gold Medalist",
    "Former Football Player"
  ],
  description: "Isaiah brings a strong athletic foundation to Brazilian Jiu-Jitsu through his years as a competitive football player. His transition to the mats has been impressive, highlighted by a gold medal performance at the Submission Arts United tournament. With his natural athleticism, discipline, and determination, Isaiah continues to grow as a grappler and competitor.",
  image: Isaiah,
  link: "https://www.instagram.com/vieux.fm", // add his IG if you’d like
}
]
  
  export default CoachesList;
  